import axios from "./axios-config";

export const getAllCourses = async (keyword, page) => {

    let { data } = await axios.get(`/super-admin/courses?keywords=${keyword ?? ""}&page=${page}`)
    return (data);

}
export const getAllCoursesWithoutPaginate = async (keyword, page) => {

    let { data } = await axios.get(`/super-admin/courses?type=all`)
    return (data);

}

export const getSingleCourse = async (id) => {

    let { data } = await axios.get(`/super-admin/courses/` + id)
    return data;

}
export const deleteSingleCourse = async (id) => {
    let { data } = await axios.delete(`/super-admin/courses/` + id)
    return data;
}

export const updateSingleCourse = async (updateData) => {

    let { data } = await axios.post(`/super-admin/courses/${updateData.id}?_method=put`, updateData.data)
    return data;
}

export const storeSingleCourse = async (storeData) => {

    let { data } = await axios.post(`/super-admin/courses`, storeData)
    return data
}

